<template>
  <div align="center">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <img src="../../assets/img/jt.gif" /><a
        href="javascript:history.go(-1)"
        >{{ $t("anonymou_currpage") }}</a
      >
      <img src="../../assets/img/jt.gif" />{{ $t("document_air_title") }}
    </div>
    <div>
      <!--table-->
      <table width="98%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="25%" align="left">
            <b> {{ $t("normal_billtype") }}:</b> &nbsp;
            <select property="bill_type" v-model="addEntity.BillType">
              <option value="M">M</option>
              <option value="D">D</option>
              <option value="H">H</option>
            </select>
          </td>
          <td width="25%" align="left">
            <b>{{ $t("anonymou_house_no") }}:</b> &nbsp;
            <!-- <c:if test="${param.method=='modify' || param.method=='houmodify'}"> -->
            <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="house_no" value="${temp.house_no}" readonly="true"/> -->
            <input
              type="text"
              name="house_no"
              v-model="addEntity.HouseNo"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
              :readonly="Isreadonly"
            />
            <!-- </c:if>
          <c:if test="${param.method=='addairbill'}"> </c:if>
              <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="house_no" value="${temp.house_no}"/> -->
          </td>
          <td width="25%" align="left">
            <b>{{ $t("normal_mawb") }}:</b> &nbsp;
            <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="master_no" value="${temp.master_no}"/> -->
            <input
              type="text"
              name="master_no"
              v-model="addEntity.MasterNo"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
          </td>
          <td width="25%" align="left">
            <b>{{ $t("normal_billdate") }}:</b> &nbsp;
            <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="bill_date" value="${temp.bill_date}"/> -->
            <input
              type="text"
              name="bill_date"
              v-model="addEntity.BillDate"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
          </td>
        </tr>
      </table>

      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tbody>
          <tr class="tr3">
            <td class="tr2" width="15%">{{ $t("normal_shprcode") }} :</td>
            <td valign="middle" align="left">
              &nbsp;
              <select property="shpr_code" v-model="addEntity.ShprCode">
                <!-- <html:options name="list"/> -->
                <option v-for="value in ListUserCode" :key="value"  :value="value" >{{value}}</option>
              </select>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_shprename") }} :</td>
            <td valign="middle" align="left">
              &nbsp;
              <input
                type="text"
                name="shpr_eaddr"
                size="40"
                v-model="addEntity.ShprEname"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_shpradd") }} :</td>
            <td valign="middle" align="left">
              &nbsp;
              <input
                type="text"
                name="shpr_eaddr"
                size="90"
                v-model="addEntity.ShprEaddr"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>

          <tr class="tr3">
            <td class="tr4">{{ $t("normal_cneecode") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <select
                property="cnee_code"
                v-model="addEntity.CneeCode"
              >
               <option v-for="value in ListUserCode" :key="value"  :value="value" >{{value}}</option>
                <options name="list" />
              </select>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr4">{{ $t("normal_consignee") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <input
                type="text"
                name="cnee_ename"
                size="40"
                v-model="addEntity.CneeEname"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="cnee_ename" value="${temp.cnee_ename}" size="40"/> -->
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr4">{{ $t("normal_cneeadd") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <input
                type="text"
                name="cnee_eaddr"
                size="90"
                v-model="addEntity.CneeEaddr"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="cnee_eaddr" value="${temp.cnee_eaddr}" size="90"/> -->
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table width="98%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="35%" align="left">
            <b> {{ $t("normal_orgncode") }}:</b> &nbsp;
            <input
              type="text"
              name="orgn_code"
              size="10"
              v-model="addEntity.OrgnCode"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
            &nbsp;
            <input
              type="text"
              name="orgn_descp"
              v-model="addEntity.OrgnDescp"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
          </td>
          <td width="35%" align="left">
            <b> {{ $t("normal_dest") }}:</b>
            &nbsp;
            <input
              type="text"
              name="dest_code"
              size="10"
              v-model="addEntity.DestCode"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
            <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="dest_code" value="${temp.dest_code}" size="10"/>  -->
            &nbsp;
            <input
              type="text"
              name="dest_descp"
              v-model="addEntity.DestDescp"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
            <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="dest_descp" value="${temp.dest_descp}"/> -->
          </td>
          <td width="30%"></td>
        </tr>
      </table>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tbody>
          <tr class="tr3">
            <td width="15%" height="18" valign="middle" class="tr2">
              {{ $t("normal_fligde") }}
              :
            </td>
            <td width="21%" valign="middle">{{ $t("normal_city") }}</td>
            <td width="20%" valign="middle">{{ $t("normal_flino") }}</td>
            <td width="22%" valign="middle">{{ $t("normal_etd") }}</td>
            <td width="22%" valign="middle">{{ $t("normal_eta") }}</td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_first") }}</td>
            <td>
              <input
                type="text"
                name="to1_city"
                v-model="addEntity.To1City"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td>
              <input
                type="text"
                name="flt_no1"
                v-model="addEntity.FltNo1"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="flt_no1" value="${temp.flt_no1}"/> -->
            </td>
            <td>
              <input
                type="text"
                name="etd_date1"
                v-model="addEntity.EtdDate1"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="etd_date1" value="${temp.etd_date1}"/> -->
            </td>
            <td>
              <input
                type="text"
                name="eta_date1"
                v-model="addEntity.EtaDate1"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="eta_date1" value="${temp.eta_date1}"/> -->
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_sec") }}</td>
            <td>
              <input
                type="text"
                name="to2_city"
                v-model="addEntity.To2City"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="to2_city" value="${temp.to2_city}"/> -->
            </td>
            <td>
              <input
                type="text"
                name="flt_no2"
                v-model="addEntity.FltNo2"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="flt_no2" value="${temp.flt_no2}"/> -->
            </td>
            <td>
              <input
                type="text"
                name="etd_date2"
                v-model="addEntity.EtdDate2"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="etd_date2" value="${temp.etd_date2}"/> -->
            </td>
            <td>
              <input
                type="text"
                name="eta_date2"
                v-model="addEntity.EtaDate2"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="eta_date2" value="${temp.eta_date2}"/> -->
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_thir") }}</td>
            <td>
              <input
                type="text"
                name="to3_city"
                v-model="addEntity.To3City"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="to3_city" value="${temp.to3_city}"/> -->
            </td>
            <td>
              <input
                type="text"
                name="flt_no3"
                v-model="addEntity.FltNo3"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="flt_no3" value="${temp.flt_no3}"/> -->
            </td>
            <td>
              <input
                type="text"
                name="etd_date3"
                v-model="addEntity.EtdDate3"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="etd_date3" value="${temp.etd_date3}"/> -->
            </td>
            <td>
              <input
                type="text"
                name="eta_date3"
                v-model="addEntity.EtaDate3"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="eta_date3" value="${temp.eta_date3}"/> -->
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table width="98%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="25%" align="left">
            <b> {{ $t("normal_pkg") }}:</b> &nbsp;
            <input
              type="text"
              name="qty"
              v-model="addEntity.Qty"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
            <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="qty" value="${temp.qty}"/> -->
          </td>
          <td width="50%" align="left">
            <b> {{ $t("normal_pkgde") }}:</b> &nbsp;
            <input
              type="text"
              name="qty_descp"
              v-model="addEntity.QtyDescp"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
            <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="qty_descp" value="${temp.qty_descp}"/> -->
          </td>
          <td width="25%">
            <b> {{ $t("normal_comm") }}:</b> &nbsp;
            <input
              type="text"
              name="cmdty_name"
              v-model="addEntity.CmdtyName"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
            <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="cmdty_name" value="${temp.cmdty_name}"/> -->
          </td>
        </tr>
      </table>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tbody>
          <tr class="tr3">
            <td width="15%" height="18" valign="middle" class="tr2">
              {{ $t("gw") }}:
            </td>
            <td width="18%" valign="middle">
              &nbsp;
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="gw" value="${temp.gw}"/> -->
              <input
                type="text"
                name="gw"
                v-model="addEntity.Gw"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td width="15%" valign="middle" class="tr2">{{ $t("cw") }}:</td>
            <td width="18%" valign="middle">
              &nbsp;
              <input
                type="text"
                name="cw"
                v-model="addEntity.Cw"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="cw" value="${temp.cw}"/> -->
            </td>
            <td width="15%" valign="middle" class="tr2">{{ $t("vw") }} :</td>
            <td width="19%" valign="middle">
              &nbsp;
              <input
                type="text"
                name="vw"
                v-model="addEntity.Vw"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="vw" value="${temp.vw}"/> -->
            </td>
          </tr>
          <tr class="tr3">
            <td height="18" valign="middle" class="tr2">
              {{ $t("currency") }}:
            </td>
            <td valign="middle">
              &nbsp;
              <input
                type="text"
                name="crncy_code"
                v-model="addEntity.CrncyCode"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="crncy_code" value="${temp.crncy_code}"/> -->
            </td>
            <td valign="middle" class="tr2">{{ $t("freight") }}</td>
            <td valign="middle">
              &nbsp;
              <input
                type="text"
                name="frt_term"
                v-model="addEntity.FrtTerm"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="frt_term" value="${temp.frt_term}"/> -->
            </td>
            <td valign="middle" class="tr2">{{ $t("other") }}</td>
            <td valign="middle">
              &nbsp;
              <input
                type="text"
                name="oth_term"
                v-model="addEntity.OthTerm"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              <!-- <html:text onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="oth_term" value="${temp.oth_term}"/> -->
            </td>
          </tr>
          <tr class="tr3">
            <td height="18" valign="middle" class="tr2">
              {{ $t("normal_marks") }}:
            </td>
            <td colspan="5" anlign="middle" align="left">
              &nbsp;
              <textarea
                name="marks"
                v-model="addEntity.Marks"
                rows="3"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              ></textarea>
              <!-- <html:textarea onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="marks" value="${temp.marks}" rows="3"/> -->
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_descp") }}:</td>
            <td colspan="5" valign="middle" align="left">
              &nbsp;
              <textarea
                name="goods_descp"
                rows="3"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
                v-model="addEntity.GoodsDescp"
              ></textarea>
              <!-- <html:textarea onmouseover="this.style.backgroundColor = '#FFFFE4'" onmouseout="this.style.backgroundColor = ''" property="goods_descp" value="${temp.goods_descp}" rows="3"/> -->
            </td>
          </tr>
          <tr class="tr3">
            <td colspan="6" valign="middle" align="center">
              <input type="submit" :value="$t('submit')" @click="submitAwb" />
              &nbsp;
              <input type="reset" :value="$t('reset')" @click="resetAwb" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import { GetUserCodeList } from "@/api/user";
import { AddAwbBI } from "@/api/TransportReport";
export default {
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {
      addEntity: {
        AwbBlType:'A',
        BillType: "M",
        HouseNo: "",
        MasterNo: "",
        BillDate: "",
        ShprCode: "",
        ShprEname: "",
        ShprEaddr: "",
        CneeCode: "",
        CneeEname: "",
        CneeEaddr: "",
        OrgnCode: "",
        OrgnDescp: "",
        DestCode: "",
        DestDescp: "",
        To1City: "",
        FltNo1: "",
        EtdDate1: "",
        EtaDate1: "",
        To2City: "",
        FltNo2: "",
        EtdDate2: "",
        EtaDate2: "",
        To3City: "",
        FltNo3: "",
        EtdDate3: "",
        EtaDate3: "",
        Qty: "",
        QtyDescp: "",
        CmdtyName: "",
        Gw: "",
        Cw: "",
        Vw: "",
        CrncyCode: "",
        FrtTerm: "",
        OthTerm: "",
        Marks: "",
        GoodsDescp: "",
      },
      Isreadonly: false,
      ListUserCode:[],
    };
  },
async  mounted(){
  //获取当前的用户code
    await GetUserCodeList({}).then(res=>{
    this.ListUserCode =res.data;
    this.addEntity.ShprCode=res.data[0];
    this.addEntity.CneeCode=res.data[0];
    }).catch(error=>{

    })

  },
  methods:{
  async  submitAwb(){
   await AddAwbBI(this.addEntity).then(res=>{
  //  console.log(res)
    }).catch(error=>{

    })
    },
    resetAwb(){

    }
  }
  
};
</script>
<style scoped>
</style>